import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from 'app/auth/models';

@Injectable({ providedIn: 'root' })
export class UserService {

  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}
  user = "Ruan Luiz";
  email= "ruan@empresa.com"

  /**
   * Get all users
   */
  getAll() {
    return this._http.get<User[]>(process.env.APIURL + "users");
  }

  /**
   * Get user by id
   */
  getById(id: number) {
    return this._http.get<User>(`${process.env.APIURL}users/${id}`);
  }
}
